import React, { useRef, useState } from "react";
import { Button, CircularProgress } from "@material-ui/core";
import { toast } from "react-toastify";
import api from "../../services/api";
import toastError from "../../errors/toastError";

/**
 * Botões de exportar/importar planilha de tags.
 * @param {number} kanban - 0 = tags de contato, 1 = kanban/funil
 * @param {function} onImported - callback após import (ex.: recarregar lista)
 */
const TagImportExportButtons = ({ kanban = 0, onImported }) => {
  const inputRef = useRef(null);
  const [exporting, setExporting] = useState(false);
  const [importing, setImporting] = useState(false);

  const handleExport = async () => {
    try {
      setExporting(true);
      const { data } = await api.get("/tags/export", {
        params: { kanban },
        responseType: "blob",
      });
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download =
        kanban === 1 ? "tags-kanban.xlsx" : "tags-contato.xlsx";
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      toast.success("Planilha de tags exportada");
    } catch (err) {
      toastError(err);
    } finally {
      setExporting(false);
    }
  };

  const handleImportClick = () => {
    if (inputRef.current) {
      inputRef.current.value = "";
      inputRef.current.click();
    }
  };

  const handleFileChange = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);
    formData.append("kanban", String(kanban));

    try {
      setImporting(true);
      const { data } = await api.post("/tags/import", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      toast.success(
        `Importação concluída: ${data.created || 0} criadas, ${
          data.updated || 0
        } atualizadas, ${data.ignored || 0} ignoradas`
      );
      if (typeof onImported === "function") {
        onImported(data);
      }
    } catch (err) {
      toastError(err);
    } finally {
      setImporting(false);
    }
  };

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept=".xls,.xlsx"
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
      <Button
        variant="outlined"
        color="primary"
        onClick={handleExport}
        disabled={exporting || importing}
      >
        {exporting ? <CircularProgress size={20} /> : "Exportar"}
      </Button>
      <Button
        variant="outlined"
        color="primary"
        onClick={handleImportClick}
        disabled={exporting || importing}
        style={{ marginLeft: 8 }}
      >
        {importing ? <CircularProgress size={20} /> : "Importar"}
      </Button>
    </>
  );
};

export default TagImportExportButtons;
